// src/utils/badges.js

// --- WAŻNE: Zaimportuj tutaj wszystkie swoje obrazki odznak ---
// Poniżej użyto tej samej ikony jako przykładu. Podmień je na właściwe.
import orzelBrak from '../img/icons/odznaka_brak.png'; // Przykładowa ścieżka
import orzelBraz from '../img/icons/odznaka_brazowa.png'; // Przykładowa ścieżka
import orzelSrebrna from '../img/icons/odznaka_srebrna.png'; // Przykładowa ścieżka
import orzelZlota from '../img/icons/odznaka_zlota.png'; // Przykładowa ścieżka
// ----------------------------------------------------------------

/**
 * Konfiguracja progów, kolorów i obrazków dla odznak za serię.
 */
export const badgeConfig = [
    // Poziomy od najniższego do najwyższego
    { level: 'Brązowa', days: 1, color: '#8B4513', image: orzelBraz },
    { level: 'Srebrna', days: 6, color: '#606060', image: orzelSrebrna },
    { level: 'Złota', days: 31, color: '#B8860B', image: orzelZlota },
];

/**
 * Zwraca informacje o aktualnej odznace na podstawie liczby dni w serii.
 * @param {number} streak - Liczba dni w serii.
 * @returns {object} Obiekt zawierający { levelName, badgeColor, image }.
 */
export const getBadgeStatus = (streak) => {
    // Sprawdzamy od najwyższego progu do najniższego
    for (let i = badgeConfig.length - 1; i >= 0; i--) {
        if (streak >= badgeConfig[i].days) {
            const currentBadge = badgeConfig[i];
            return {
                levelName: `${currentBadge.level} Odznaka`,
                badgeColor: currentBadge.color,
                image: currentBadge.image,
            };
        }
    }

    // Jeśli żaden próg nie został osiągnięty
    return {
        levelName: null,
        badgeColor: '#A9A9A9', // Kolor dla braku odznaki
        image: orzelBrak,      // Obrazek dla braku odznaki
    };
};

/**
 * Zwraca informacje o progu do następnej odznaki.
 * @param {number} currentStreak - Obecna liczba dni w serii.
 * @returns {object|null} Obiekt z danymi o następnej odznace lub null.
 */
export const getNextBadgeInfo = (currentStreak) => {
    const nextBadge = badgeConfig.find(badge => currentStreak < badge.days);
    if (!nextBadge) return null;
    
    return { 
        level: nextBadge.level, 
        totalDays: nextBadge.days, 
        currentStreak: currentStreak 
    };
};